import React, { Component } from 'react';
import { GenericSimpleButton, GenericModal, GenericModalButton } from 'com-gyf-webcore-userinterfacecomponents';
import 'rc-dialog/assets/bootstrap.css';
import SelectCommonDefault from './Common/SelectCommonDefault';



class FormaDePago extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {

        const { data, selectCombo, tarjetas } = this.props;
        

        //MAPEO EN FORMAS DE PAGO PARA QUE COINCIDA CON EL COMPONENTE SELECTCOMMON
        let formasDePago = data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID.map((formaPago) => { return { Id: formaPago.FormaPagoId, Descripcion: formaPago.Descripcion, Codigo: formaPago.Codigo} });
        let formasDebito = data.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID.map((formaDebito) => { return { Id: formaDebito.FormaDebitoId, Descripcion: formaDebito.Descripcion } });
        let parametrosGenerales = data.GET_ATLAS_PARAMETRO_GENERAL;

        let formaDebitoSelectedDesc = data.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID.filter(formaDebito => formaDebito.FormaDebitoId == data.formaDebitoId);
        formaDebitoSelectedDesc = formaDebitoSelectedDesc.length > 0 ? formaDebitoSelectedDesc[0].Descripcion : null;


        //LAS CUENTAS QUE SE MUESTRAN SE FILTRAN DE ACUERDO A SUCURSAL
        let sucursalPesos = data.SUCURSALES_CUENTAS_PESOS;
        let sucursalDolares = data.SUCURSALES_CUENTAS_DOLARES;
        
        let errorSinCuentasALaVista=null;
        let cuentasCliente = tarjetas.clienteResultadoBusqueda.clienteListaDocumentos;
        if((cuentasCliente && cuentasCliente[0] && !cuentasCliente[0].hasOwnProperty('Id')) || cuentasCliente && !cuentasCliente[0] ){
            //SI EL CLIENTE NO TIENE CUENTAS BANCARIAS DISPONIBLES SOLO SE PERMITE PAGO EFECTIVO
            formasDePago = formasDePago.filter(forma=> forma.Codigo == "EFECTIVO")
            if(formasDePago.length<1){
                //si el producto no permite formas de pago en efectivo no se permite seguir
                errorSinCuentasALaVista = "El Producto seleccionado no permite el pago voluntario como forma de pago y el Cliente no posee cuentas a la vista en la Entidad válidas para el débito de este Producto."
            }
        }
        
        let filtroPeso = "0";
        let filtroDolar = "0";

        sucursalPesos.map(suc=>{
            if(suc.Id == data.sucursalCuentaPesosId) filtroPeso = suc.VALOR_X;
            if(suc.Id == data.sucursalCuentaDolaresId) filtroDolar = suc.VALOR_X;
        })


        let cuentaPesos = cuentasCliente && cuentasCliente.filter((cuenta=>cuenta.Moneda == "80" && cuenta.Sucursal == filtroPeso));
        let cuentaDolares = cuentasCliente && cuentasCliente.filter((cuenta=>cuenta.Moneda != "80" && cuenta.Sucursal == filtroDolar));
        


        let esDebitoEnCuenta = false;
        let valoresDefault = {};
        
        if (tarjetas.esModificacion == false) {
            if (tarjetas.administradora.Id == 1) {
                valoresDefault = data.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO
            } else if (tarjetas.administradora.Id == 2) {

                valoresDefault = data.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO ? data.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO : {}
            }
        } else {
            valoresDefault = tarjetas.datosSolicitud;
        }

        if (data.formaPagoId) {
            let formaPago = data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID.filter(formasDePago => formasDePago.FormaPagoId == data.formaPagoId)

            if (formaPago && formaPago.length > 0)
                esDebitoEnCuenta = formaPago[0].EsDebitoEnCuenta;
        }

        if (!esDebitoEnCuenta && data.formaDebitoId) {
            selectCombo("formaDebitoId", null);
            selectCombo("sucursalCuentaPesosId", null);
            selectCombo("cuentaPesosId", null);
            selectCombo("sucursalCuentaDolaresId", null);
            selectCombo("cuentaDolaresId", null);
        }
        if(errorSinCuentasALaVista && (Array.isArray(data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID) && data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID.length>0)){
            return(
                <div className="row">
                    <div className="col-md-12">                
                        <div className="divisor-section bottom-separator" >
                            <h2>Forma de Pago</h2>
                        </div>                
                        <div className="form-group bottom-separator-xs datos-generales-cuenta">
                            <label className="error">{errorSinCuentasALaVista}</label>
                        </div>
                    </div>
                </div>
            )
        }else{
            return (
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="correspondencia-contacto-cliente col-md-12">
                                <div className="divisor-section bottom-separator" >
                                    <h2>Forma de Pago</h2>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group bottom-separator-xs datos-generales-cuenta">
                                    <label className="label-primary">Forma de Pago</label>
                                    <SelectCommonDefault infoData={formasDePago} valorCombo={valoresDefault["FormaPagoDefaultId"] ? valoresDefault["FormaPagoDefaultId"] : valoresDefault["FormaPagoId"]} selectCombo={selectCombo} nombreAction={"formaPagoId"} selecciones={data} />
                                </div>
    
                                {(!data.ERROR_CUENTA["formaPagoId"])
                                    && <label className="error">{"Debe seleccionar una forma de pago."}</label>}
    
                            </div>
    
                            {esDebitoEnCuenta ?
                                (<div className="col-md-12">
                                    <div className="form-group bottom-separator-xs datos-generales-cuenta">
                                        <label className="label-primary">Forma de Débito</label>
                                        <SelectCommonDefault infoData={formasDebito} valorCombo={valoresDefault["TipoDebitoDefaultId"] ? valoresDefault["TipoDebitoDefaultId"] : valoresDefault["FormaDebitoId"]} selectCombo={selectCombo} nombreAction={"formaDebitoId"} selecciones={data} />
    
                                        {(esDebitoEnCuenta && !data.ERROR_CUENTA["formaDebitoId"])
                                            && <label className="error">{"Debe seleccionar una forma de debito."}</label>}
    
                                    </div>
                                </div>) : null}
    
                            {data.formaDebitoId && esDebitoEnCuenta ?
                                (<div className="col-md-12">
                                    <div className="form-group bottom-separator-xs datos-generales-cuenta">
                                        <label className="label-primary">Cuenta de Débito en $</label>
                                        <SelectCommonDefault placeholder={"Seleccione Sucursal de Radicación..."} classSelected={"select-separate-bottom"} infoData={sucursalPesos} valorCombo={valoresDefault["SucursalCuentaPesosDefaultId"] ? valoresDefault["SucursalCuentaPesosDefaultId"] : valoresDefault["sucursalCuentaPesosId"]} selectCombo={selectCombo} nombreAction={"sucursalCuentaPesosId"} selecciones={data} />
                                        <SelectCommonDefault classSelected={"select-separate-bottom"} infoData={cuentaPesos} valorCombo={valoresDefault["CuentaPesosDefaultId"] ? valoresDefault["CuentaPesosDefaultId"] : valoresDefault["cuentaPesosId"]} selectCombo={selectCombo} nombreAction={"cuentaPesosId"} selecciones={data} />
    
                                        {(esDebitoEnCuenta && (!data.ERROR_CUENTA["sucursalCuentaPesosId"] || !data.ERROR_CUENTA["cuentaPesosId"]))
                                            && <label className="error">{"Si selecciona una cuenta en pesos, debe seleccionar la sucursal y viceversa."}</label>}
    
                                    </div>
                                </div>) : null}
    
                            {(sucursalDolares.length > 0 && data.formaDebitoId && esDebitoEnCuenta && parametrosGenerales.SINODEBITOCUENTADOLAR) ?
                                (<div className="col-md-12">
                                    <div className="form-group bottom-separator-xs datos-generales-cuenta">
                                        <label className="label-primary">Cuenta de Débito en U$S</label>
                                        <SelectCommonDefault placeholder={"Seleccione Sucursal de Radicación..."} classSelected={"select-separate-bottom"} infoData={sucursalDolares} valorCombo={valoresDefault["SucursalCuentaDolaresDefaultId"] ? valoresDefault["SucursalCuentaDolaresDefaultId"] : valoresDefault["sucursalCuentaDolaresId"]} selectCombo={selectCombo} nombreAction={"sucursalCuentaDolaresId"} selecciones={data} />
                                        <SelectCommonDefault classSelected={"select-separate-bottom"} infoData={cuentaDolares} valorCombo={valoresDefault["CuentaDolaresDefaultId"] ? valoresDefault["CuentaDolaresDefaultId"] : valoresDefault["cuentaDolaresId"]} valorCombo={data.cuentaDolaresId ? data.cuentaDolaresId : null} selectCombo={selectCombo} nombreAction={"cuentaDolaresId"} selecciones={data} />
    
                                        {(esDebitoEnCuenta && parametrosGenerales.SINODEBITOCUENTADOLAR && (!data.ERROR_CUENTA["sucursalCuentaDolaresId"] || !data.ERROR_CUENTA["cuentaDolaresId"]))
                                            && <label className="error">{"Si selecciona una cuenta en dolares, debe seleccionar la sucursal y viceversa."}</label>}
    
    
                                    </div>
                                </div>) : null}
    
    
                            {(esDebitoEnCuenta && formaDebitoSelectedDesc && formaDebitoSelectedDesc == "PAGO MINIMO" && data.cuentaPesosId && data.cuentaPesosId != "0" && data.cuentaDolaresId && data.cuentaDolaresId != "0")
                                &&
                                (<div className="col-md-12">
                                    <label className="error">{"Al seleccionar pago mínimo, se debe seleccionar una única cuenta."}</label>
                                </div>)
                            }
    
                            {(esDebitoEnCuenta && !data.ERROR_CUENTA["cuentaSelected"])
                                &&
                                (<div className="col-md-12">
                                    <label className="error">{"Debe seleccionar al menos una cuenta."}</label>
                                </div>)
                            }
    
                        </div>
                    </div>
                </div>
            )
        }
        
    }
}

export default FormaDePago;